// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.44.2/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".powered-by-vim {\n  display: flex;\n  align-items: center;\n  position: fixed;\n  bottom: 0;\n  right: 0;\n  background: #fff;\n  padding: 10px 20px 10px 25px;\n  border-radius: 100px 0 0 0;\n  box-shadow: 0 0 20px 0 rgba(8, 58, 107, 0.15);\n  height: 37px;\n}\n.powered-by-vim .svg-icon {\n  width: 35px;\n  height: auto;\n  margin: 0 0 0 5px;\n}\n", ""]);
// Exports
module.exports = exports;
